import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private alertController: AlertController) {}

  async presentNotificationAlert(
    type: 'error' | 'success' | 'warning',
    title: string,
    message: string
  ) {
    const alert = await this.alertController.create({
      header: title,
      message,
    });

    await alert.present();
    setTimeout(async () => {
      await alert.dismiss();
    }, 3000);
  }

  async presentConfirmationAlert(title: string, message: string) {
    const alert = await this.alertController.create({
      header: title,
      message,
      cssClass: 'text-center',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Confirm',
          role: 'confirm',
        },
      ],
    });

    await alert.present();
    const { role } = await alert.onDidDismiss();
    return role;
  }
}
